import React  from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { push } from 'react-router-redux'

const MobileLink = ({ className, dataTestId, label, value, onClick, skipRouter, outboundLocation, handleClose=()=>{}, push}) => {
  let link
  if (skipRouter) {
      link = (
      <Link to='#' className={className} onClick={(e) => {
        onClick(e)
        handleClose()
      }}>
        {dataTestId || label}
      </Link>
    )
  } else if (outboundLocation) {
    link = (
      <a href={outboundLocation} className={className} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    )
  } else {
    link = (
      <a className={className} data-testid={dataTestId || label} onClick={() => {
        push({pathname:value})
        handleClose()
      }}>
        {label}
      </a>
    )
  }
  return (<div>{ link }</div>)
}

export const ConnectedMobileLink = connect(null, dispatch => ({
  push: obj => dispatch(push(obj))
}))(MobileLink)

export default styled(ConnectedMobileLink)`
  font-size: 18px;
  font-family: "Circular", sans-serif;
  font-weight: ${props => props.active ? '900' : '300'};
  color: #ffffff;
  line-height: 50px;
  text-align: left;
  ${props => props.active ?
    'border-bottom: 1px solid rgba(241, 241, 244, 0.44);' :
    ''
  }

  :hover, :focus, :visited {
    text-decoration: none;
    color: #ffffff;
  }
`
